//REV-21363 — types of the SHARED document preview.
//
//EXTRACTED from `document-detail` (REV-21368), where the preview was rendered inline. Two surfaces
//now show the same preview — the single-document page (REV-21368) and the account documents area
//(this ticket) — and the preview carries a documented SECURITY CONTROL (SRR REV-21368 F1). A
//copy-paste would have duplicated that control into a second place with none of its tests.

/**
 * What the browser is asked to show. `pdf` is the only kind the embedded viewer handles;
 * everything else gets a labelled placeholder.
 *
 * ⚠️ INGEST is PDF-only (ADR-0009 §12), DISPLAY is not: agent-generated `.xlsx` documents genuinely
 * exist in a closing, so `other` is a REGULAR state and never an error.
 */
export type DocumentPreviewKind = 'pdf' | 'other';
